import { render, staticRenderFns } from "./confirm-email-item.vue?vue&type=template&id=7837ba26&scoped=true&"
import script from "./confirm-email-item.vue?vue&type=script&lang=js&"
export * from "./confirm-email-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7837ba26",
  null
  
)

export default component.exports